/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EServices.css';
import pans from './panStyle.scss';
import _ from 'lodash';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import fetch from '../../core/fetch';
import { connect } from 'react-redux';
import { countAction, trackEvent } from '../../lib/utils';

class LinkRedirector extends React.Component {


    state = {
        eserviceDistrict: null,
        redirect_to: null,
    }

    componentWillMount() {
        fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
            .then(r => r.json())
            .then(resp => {
                this.setState({
                    eserviceDistrict: resp
                })
            })
    }

    render() {
        if (this.state.eserviceDistrict && this.state.eserviceDistrict.link) {
            trackEvent({ category: 'redirect', action: 'click', name: this.props.serviceInfo.eservice.title });
            countAction(this.props.prefix, 4, 1, this.props.serviceInfo.eservice.id)
            .then(() => {
                window.location.replace(this.state.eserviceDistrict.link);
            });
        }
        return (
            <div className={s.root}>
                <div className={s.container}>
                    <div style={{ textAlign: 'center' }}>
                        <GrayPanel title="" bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}><img alt="Loader" src={waiting} /></GrayPanel>
                    </div>
                </div>
            </div>
        );
    }
}

LinkRedirector.propTypes = {
    serviceInfo: PropTypes.object,
    district: PropTypes.string,
};

const mapState = state => ({
    current_service: state.eservices.current,
    districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(pans)(withStyles(s)(connect(mapState, mapDispatch)(LinkRedirector)));


// WEBPACK FOOTER //
// src/routes/eservices/LinkRedirector.js